export default __webpack_public_path__ + "static/media/Tiger's Straps of Crouching Calm.33b3c42b.jpg";